export default __webpack_public_path__ + "static/media/real2.463df74c.png";